import CategoryPolicy from "./CategoryPolicy";

export default CategoryPolicy;
